/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GonzaloApiResponseDto {
  code?: number;
  coveredAreaPercentage?: number;
  error?: boolean;
  errormessage?: string;
  maxLat?: number;
  maxLon?: number;
  message?: string;
  minLat?: number;
  minLon?: number;
  overlapAreaPercentage?: number;
  routes?: Array<Array<{ [key: string]: number }>>;
  stats?: string;
  travelledDistance?: number;
  travelledTime?: number;
  uncoveredAreaPercentage?: number;
  workedDistance?: number;
  workedTime?: number;
}
